import {
    FETCH_MESSAGES_SUCCESS,
    FETCH_MESSAGES_FAILURE,
    CREATE_MESSAGE_SUCCESS,
    CREATE_MESSAGE_FAILURE,
    UPDATE_MESSAGE_SUCCESS,
    UPDATE_MESSAGE_FAILURE,
    THUMBS_UP_SUCCESS,
    THUMBS_UP_FAILURE,
    THUMBS_DOWN_SUCCESS,
    THUMBS_DOWN_FAILURE,
    COPY_MESSAGE_SUCCESS,
    COPY_MESSAGE_FAILURE,
    REGENERATE_BUTTON_SUCCESS,
    REGENERATE_BUTTON_FAILURE,
    GENERATE_MESSAGE_SUCCESS,
    GENERATE_MESSAGE_FAILURE,
    LOGOUT_SUCCESS,
    CLEAR_MESSAGES_SUCCESS,
    CLEAR_MESSAGE_ERROR,
  } from './actionTypes.js';
  
  const initialState = {
    messages: [],
    loading: false,
    error: null,
  };
  
  const messageReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_MESSAGES_SUCCESS:
        return { ...state, messages: action.payload, error: null };

      case FETCH_MESSAGES_FAILURE:
        return { ...state, error: action.payload };

      case CREATE_MESSAGE_SUCCESS:
        return { ...state, messages: [...state.messages, action.payload], error: null };
  
      case CREATE_MESSAGE_FAILURE:
        return { ...state, error: action.payload };

      case UPDATE_MESSAGE_SUCCESS:
        return { ...state, messages: state.messages.map(message => message.message_id === action.payload.message_id ? action.payload : message), error: null };

      case UPDATE_MESSAGE_FAILURE:
        return { ...state, error: action.payload };
  
      case THUMBS_UP_SUCCESS:
      case THUMBS_DOWN_SUCCESS:
      case COPY_MESSAGE_SUCCESS:
        return { ...state, error: null };
  
      case THUMBS_UP_FAILURE:
      case THUMBS_DOWN_FAILURE:
      case COPY_MESSAGE_FAILURE:
        return { ...state, error: action.payload };
  
      case GENERATE_MESSAGE_SUCCESS: {
        const { response, message_id } = action.payload;
        return {
          ...state,
          messages: state.messages.map(message =>
            message.message_id === message_id
              ? { ...message, content: (message.content || "") + response}
              : message
          ),
          error: null,
        };
      }

      case REGENERATE_BUTTON_SUCCESS: 
        return { ...state, error: null };

      case REGENERATE_BUTTON_FAILURE:
        return { ...state, error: action.payload };
    
      case GENERATE_MESSAGE_FAILURE:
        return { ...state, error: action.payload };

      case LOGOUT_SUCCESS:
        return { ...state, messages: [], loading: null, error: null };

      case CLEAR_MESSAGES_SUCCESS:
        return { ...state, messages: [], loading: null, error: null };

      case CLEAR_MESSAGE_ERROR:
        return { ...state, error: null };
  
      default:
        return state;
    }
  };
  
  export default messageReducer;
  